import { CommonModule } from '@angular/common';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-checkbox-toggle',
  templateUrl: './checkbox-toggle.component.html',
  styleUrl: './checkbox-toggle.component.scss',
  standalone: true,
  imports: [CommonModule],
})
export class CheckboxToggleComponent {
    @Input() isChecked = false;
    @Input() disabled = false;
    @Output() onChecked= new EventEmitter<boolean>();

    onCheckedHandle(){
        if(!this.disabled)
            this.onChecked.emit(!this.isChecked)
    }

}
